import { animated, useSprings } from '@react-spring/web';
import { useTranslation } from 'react-i18next';

import { Heading } from '@app/shared/ui/atoms/Common';
import { getCardAnimations } from '@app/shared/utils/dailyCardResult';

interface CardsSectionProps {
  imageSrc: string;
}

export function CardsSection({ imageSrc }: CardsSectionProps) {
  const { t } = useTranslation();

  const cardAnimations = getCardAnimations(imageSrc);
  const [springs] = useSprings(cardAnimations.length, (index) => cardAnimations[index].config);

  return (
    <section className="mt-1.5 flex flex-col gap-9">
      <Heading level={4} className="text-center">
        {t('daily_card_result.card_of_the_day')}
      </Heading>

      <div className="flex justify-center">
        <div className="relative min-h-[382px] w-[258px]">
          {cardAnimations.map(({ src, className }, idx) => (
            <animated.img
              key={idx}
              src={src}
              alt={`taro card ${idx + 1}`}
              className={className}
              style={springs[idx]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
